import MaturaCroatianEssayApplicationPage from "../MaturaCroatianEssayApplicationPage/MaturaCroatianEssayApplicationPage";
import LumenNavbar from "../../layout/LumenNavbar";
import NewFooter from "../../layout/NewFooter";
import { Container } from "react-bootstrap";

function NewMaturaCroatianEssayApplicationPage() {
  return (
    <>
      <LumenNavbar />
      <Container style={{ paddingBottom: "100px" }}>
        <MaturaCroatianEssayApplicationPage />
      </Container>
      <NewFooter />
    </>
  );
}

export default NewMaturaCroatianEssayApplicationPage;
